import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  printNotoTitle: {
    description: 'bulkPrintEpics.printNotoTitle',
    defaultMessage: 'Printing Labels',
    id: 'KjF6O0',
  },
  printing: {
    description: 'bulkPrintEpics.printing',
    defaultMessage: 'Starting print process.',
    id: 'UbLB7P',
  },
  labelCheck: {
    description: 'bulkPrintEpics.labelCheck',
    defaultMessage: 'Checking labels to be printed.',
    id: 'ZlvBel',
  },
});
